<div class="flex justify-between items-center w-full px-4 md:px-8 py-2 h-16">
  <button
    type="button"
    class="md:hidden text-primary p-2 flex items-center justify-center"
    aria-label="Abrir menú"
    data-testid="hamburger-btn"
    (click)="menuToggle.emit()"
  >
    <span class="material-symbols-outlined">menu</span>
  </button>
  <div class="md:hidden flex items-center gap-2">
    <app-logo-mark [size]="28" />
    <span class="text-[18px] font-extrabold text-primary">VendIA</span>
  </div>

  <div class="hidden md:flex items-center flex-1 max-w-md bg-surface-container-low rounded-full px-4 py-2 border border-outline-variant/50 focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20 transition-all">
    <span class="material-symbols-outlined text-on-surface-variant mr-2 text-[20px]">search</span>
    <input
      class="bg-transparent border-none outline-none w-full text-sm placeholder:text-on-surface-variant/70 text-on-surface"
      placeholder="Buscar..."
      type="text"
    />
  </div>

  <div class="flex items-center gap-1 md:gap-2">
    <div class="hidden lg:flex items-center gap-2 bg-secondary/10 px-3 py-1.5 rounded-full border border-secondary/20">
      <span class="relative flex h-2.5 w-2.5">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
        <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-secondary"></span>
      </span>
      <span class="text-xs text-secondary font-semibold">WhatsApp Activo</span>
    </div>

    <div class="relative" data-testid="notif-wrapper" (appClickOutside)="closeNotifPanel()">
      <button
        type="button"
        class="p-2 text-on-surface-variant hover:text-primary rounded-full hover:bg-surface-container relative"
        aria-label="Notificaciones"
        data-testid="notif-bell-btn"
        (click)="toggleNotifPanel()"
      >
        <span class="material-symbols-outlined">notifications</span>
        @if (unreadCount() > 0) {
          <span class="absolute top-1.5 right-1.5 w-2 h-2 bg-secondary rounded-full"></span>
        }
      </button>
      @if (isNotifOpen()) {
        <div class="absolute right-0 top-12" data-testid="notif-panel">
          <app-notification-panel [notifications]="notifications()" (itemClick)="onNotificationClick($event)" />
        </div>
      }
    </div>

    <button type="button" class="p-2 text-on-surface-variant hover:text-primary rounded-full hover:bg-surface-container" aria-label="Cuenta">
      <span class="material-symbols-outlined">account_circle</span>
    </button>
  </div>
</div>
